import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { getInitials } from 'utils/Strings';

interface IAvatarNameColorProps {
  name: string;
  size: number;
  className?: string;
  overlay?: boolean;
  dataTestId?: string;
}

const AvatarNameColor = (props: IAvatarNameColorProps) => {
  const initials = getInitials(props.name);
  const colors = ['#00AA55', '#009FD4', '#B381B3', '#939393', '#E3BC00', '#D47500', '#DC2A2A'];
  const charCodes = parseInt(
    initials
      .split('')
      .map((char) => char.charCodeAt(0))
      .join(''),
    10
  );

  const avatarFragment = (
    <div
      className={`avatar-name-color ${props.className || ''}`}
      style={{
        width: props.size,
        height: props.size,
        backgroundColor: colors[charCodes % colors.length]
      }}
      data-test={props.dataTestId}
    >
      <span style={{ fontSize: `${props.size * 0.4}px` }}>{initials.toUpperCase()}</span>
    </div>
  );

  if (props.overlay) {
    return (
      <OverlayTrigger
        overlay={
          <Tooltip id={`avatar-tooltip-${Math.random() * 1000}}`} data-test="avatar-tooltip">
            {props.name}
          </Tooltip>
        }
      >
        {avatarFragment}
      </OverlayTrigger>
    );
  }

  return avatarFragment;
};

export default AvatarNameColor;
